"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.AuthorizedUserTypeEnum = exports.StateEnum = void 0;
var StateEnum;
(function (StateEnum) {
    StateEnum["AB"] = "AB";
    StateEnum["AK"] = "AK";
    StateEnum["AL"] = "AL";
    StateEnum["AR"] = "AR";
    StateEnum["AZ"] = "AZ";
    StateEnum["BC"] = "BC";
    StateEnum["CA"] = "CA";
    StateEnum["CA2"] = "CA_2";
    StateEnum["CO"] = "CO";
    StateEnum["CT"] = "CT";
    StateEnum["DC"] = "DC";
    StateEnum["DE"] = "DE";
    StateEnum["FL"] = "FL";
    StateEnum["GA"] = "GA";
    StateEnum["GU"] = "GU";
    StateEnum["HI"] = "HI";
    StateEnum["IA"] = "IA";
    StateEnum["ID"] = "ID";
    StateEnum["IL"] = "IL";
    StateEnum["IN"] = "IN";
    StateEnum["KS"] = "KS";
    StateEnum["KY"] = "KY";
    StateEnum["LA"] = "LA";
    StateEnum["LS"] = "LS";
    StateEnum["MA"] = "MA";
    StateEnum["MB"] = "MB";
    StateEnum["MD"] = "MD";
    StateEnum["ME"] = "ME";
    StateEnum["MI"] = "MI";
    StateEnum["MN"] = "MN";
    StateEnum["MO"] = "MO";
    StateEnum["MS"] = "MS";
    StateEnum["MT"] = "MT";
    StateEnum["NB"] = "NB";
    StateEnum["NC"] = "NC";
    StateEnum["ND"] = "ND";
    StateEnum["NE"] = "NE";
    StateEnum["NF"] = "NF";
    StateEnum["NH"] = "NH";
    StateEnum["NJ"] = "NJ";
    StateEnum["NL"] = "NL";
    StateEnum["NM"] = "NM";
    StateEnum["NS"] = "NS";
    StateEnum["NT"] = "NT";
    StateEnum["NU"] = "NU";
    StateEnum["NV"] = "NV";
    StateEnum["NY"] = "NY";
    StateEnum["OH"] = "OH";
    StateEnum["OK"] = "OK";
    StateEnum["ON"] = "ON";
    StateEnum["OR"] = "OR";
    StateEnum["PA"] = "PA";
    StateEnum["PE"] = "PE";
    StateEnum["PR"] = "PR";
    StateEnum["QC"] = "QC";
    StateEnum["RI"] = "RI";
    StateEnum["SC"] = "SC";
    StateEnum["SD"] = "SD";
    StateEnum["SF"] = "SF";
    StateEnum["SK"] = "SK";
    StateEnum["TN"] = "TN";
    StateEnum["TX"] = "TX";
    StateEnum["UT"] = "UT";
    StateEnum["VA"] = "VA";
    StateEnum["VI"] = "VI";
    StateEnum["VT"] = "VT";
    StateEnum["WA"] = "WA";
    StateEnum["WI"] = "WI";
    StateEnum["WV"] = "WV";
    StateEnum["WY"] = "WY";
    StateEnum["YT"] = "YT";
})(StateEnum = exports.StateEnum || (exports.StateEnum = {}));
var AuthorizedUserTypeEnum;
(function (AuthorizedUserTypeEnum) {
    AuthorizedUserTypeEnum["PRIMARY"] = "PRIMARY";
    AuthorizedUserTypeEnum["SPOUSE"] = "SPOUSE";
    AuthorizedUserTypeEnum["DEPENDENT"] = "DEPENDENT";
    AuthorizedUserTypeEnum["NORMAL_USER"] = "NORMAL_USER";
    AuthorizedUserTypeEnum["OWNER"] = "OWNER";
    AuthorizedUserTypeEnum["CO_OWNER"] = "CO_OWNER";
    AuthorizedUserTypeEnum["SECONDARY"] = "SECONDARY";
    AuthorizedUserTypeEnum["TERTIARY"] = "TERTIARY";
    AuthorizedUserTypeEnum["ELDER"] = "ELDER";
    AuthorizedUserTypeEnum["ANY"] = "ANY";
    AuthorizedUserTypeEnum["ALL"] = "ALL";
})(AuthorizedUserTypeEnum = exports.AuthorizedUserTypeEnum || (exports.AuthorizedUserTypeEnum = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://eligibilities.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Benefits Eligibilities Service Api
 * @version v1
 * @baseUrl https://eligibilities.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags BenefitsEligibilities
             * @name BenefitsEligibilitiesBenefitsEligibilities
             * @request POST:/v1/users/{userId}/benefitsEligibilities
             * @secure
             */
            benefitsEligibilitiesBenefitsEligibilities: (userId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/benefitsEligibilities`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BenefitsEligibilities
             * @name BenefitsEligibilitiesBenefitsEligibilitiesByProduct
             * @request POST:/v1/users/{userId}/benefitsEligibilitiesByProduct
             * @secure
             */
            benefitsEligibilitiesBenefitsEligibilitiesByProduct: (userId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/benefitsEligibilitiesByProduct`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BenefitsEligibilities
             * @name BenefitsEligibilitiesBenefitsEligibilitiesByProduct2
             * @request POST:/v1/benefitsEligibilitiesByProduct
             * @secure
             */
            benefitsEligibilitiesBenefitsEligibilitiesByProduct2: (data, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/benefitsEligibilitiesByProduct`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BenefitsEligibilities
             * @name BenefitsEligibilitiesGetBenefitsWithProvisioning
             * @request POST:/v1/users/{userId}/benefitsProvisioning
             * @secure
             */
            benefitsEligibilitiesGetBenefitsWithProvisioning: (userId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/benefitsProvisioning`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=eligibilities.js.map